import { render, staticRenderFns } from "./FieldGhostPreview.vue?vue&type=template&id=3df23a98&scoped=true"
import script from "./FieldGhostPreview.vue?vue&type=script&lang=js"
export * from "./FieldGhostPreview.vue?vue&type=script&lang=js"
import style0 from "./FieldGhostPreview.vue?vue&type=style&index=0&id=3df23a98&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3df23a98",
  null
  
)

export default component.exports